import React, { useMemo } from 'react';
import { useRouter } from 'next/router';

import {
  OrderTypes,
  useCarouselEventsQuery,
  VersionStates,
} from '@/components/common/Providers/GraphqlProvider/generated';

import { CardEvent } from '../../Events/EventsSocialNetworks';

export const EventItemMoreEvents = ({ currentEventId }: { currentEventId?: string }) => {
  const { push } = useRouter();
  const queryVariables = useMemo(
    () => ({
      orderBy: {
        createdAt: OrderTypes.Desc,
      },
      pagination: {
        skip: 0,
        take: 4,
      },
      // where: {
      //   eventStatus: {
      //     _eq: VersionStates.Active,
      //   },
      // },
    }),
    []
  );

  const { data: eventsData } = useCarouselEventsQuery({
    variables: queryVariables,
    fetchPolicy: 'cache-first',
  });

  const filteredEvents = useMemo(() => {
    if (eventsData?.eventsItems) {
      const anyEvent = eventsData.eventsItems.some((x) => x.id == currentEventId);
      const tempEvents = eventsData.eventsItems.filter((x) => x.id != currentEventId);
      if (!anyEvent && eventsData.eventsItems.length > 0) {
        tempEvents.splice(tempEvents.length - 1, 1);
      }

      return tempEvents;
    }
  }, [eventsData?.eventsItems, currentEventId]);

  const onSelectEvent = (id: string) => {
    push(`/events/${id}`);
  };

  return (
    <div>
      <p className="mb-1 mt-8 font-montserrat text-[20px] font-semibold leading-[30px] text-primary">
        Más eventos
      </p>
      {filteredEvents?.map((event, index) => (
        <CardEvent
          key={index}
          event={event}
          index={index}
          onClick={() => onSelectEvent(event?.seo?.metadata?.at(0)?.slug || event.id)}
        />
      ))}
    </div>
  );
};
